<template>
  <span>
    <button
      class="WBMBigButton m-primary"
      v-on:click.prevent="onCopy"
      v-if="!isCopied"
    >
      Copy
    </button>
    <button
      class="WBMBigButton m-primary"
      v-on:click.prevent="onCopy"
      v-if="isCopied"
    >
      <span class="HiddenText">Copy</span>
      <span class="OverlayText">👍🏻</span>
    </button>
  </span>
</template>

<script lang="ts">
import { Vue } from "vue-property-decorator";

const CopyButton = Vue.extend({
  props: {
    text: String,
  },

  data() {
    return {
      isCopied: false,
      timeout: 0,
    };
  },

  methods: {
    onCopy() {
      if (this.timeout) {
        clearTimeout(this.timeout as number);
      }
      navigator.clipboard
        .writeText(this.text)
        .then(() => {
          this.isCopied = true;
          this.timeout = setTimeout(() => {
            this.isCopied = false;
          }, 2000) as unknown as number;
        })
        .catch(() => {
          alert(
            "Copy failed. This can happen if the browser window was out of focus. Try again."
          );
        });
    },
  },
});
export default CopyButton;
</script>

<style scoped lang="scss">
.WBMBigButton {
  position: relative;

  .HiddenText {
    visibility: hidden;
  }

  .OverlayText {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
